// extracted by mini-css-extract-plugin
module.exports = {"convertedAmount":"_dc7bbbf","smallLineHeight":"_2c7eec2"};